import React from "react";
import { IAboutUsData } from "../../exports/interfaces";

const HotelDetails = (props: { aboutUsData: IAboutUsData[] }) => {
  return (
    <>
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-33961c6 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="33961c6"
        data-element_type="section"
        data-settings='{"hoteller_ext_is_background_parallax":"false","hoteller_ext_is_background_on_scroll":"false"}'
      >
        <div className="elementor-container elementor-column-gap-default">
          <div className="elementor-row">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-99e75ce custom-elementor-element-99e75ce"
              data-id="99e75ce"
              data-element_type="column"
              data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
              style={{ padding: "0px 100px" }}
            >
              <div className="elementor-column-wrap elementor-element-populated">
                <div className="elementor-widget-wrap">
                  <div
                    className="elementor-element elementor-element-9425f29 elementor-widget elementor-widget-hoteller-timeline"
                    data-id="9425f29"
                    data-element_type="widget"
                    data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                    data-widget_type="hoteller-timeline.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="timeline_wrapper">
                        {props?.aboutUsData?.map((data) => (
                          <div className="timeline_entry">
                            <div className="timeline_title">
                              {data?.image && (
                                <div
                                  className="timeline_image"
                                  style={{
                                    position: "relative",
                                    display: "inline-block",
                                  }}
                                >
                                  <img
                                    src={`${process.env.REACT_APP_cmsUrl}${data?.image[0]?.media?.url}`}
                                    alt="hotel_details"
                                  />
                                  <div className="custom-gradient"></div>
                                </div>
                              )}
                              <h3>{data?.title}</h3>
                            </div>
                            <div className="timeline_body">
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: data?.description,
                                }}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                      <br className="clear" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HotelDetails;
